module.exports = "<button class=\"button button--icon-text\"> <span class=icon-arrow-left></span> <span translate=APP.BACK>Back</span> </button> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/back/back.template.html
// module id = 554
// module chunks = 0